import React, { useEffect, useState, useRef, useContext } from "react";
import { useSelector } from "react-redux";
import { FaGraduationCap } from "react-icons/fa";
import { FaSchool } from "react-icons/fa";
import { HiMiniIdentification } from "react-icons/hi2";
import { FaPenToSquare } from "react-icons/fa6";
import { useLocation } from "react-router-dom";
import { LoadContext } from "../../ReusableComponents/LoadingContex";
import axiosInstance from "../../ReusableComponents/Axios";
import { AssessmentName } from "../Reusablecomponents/RegularFunctions";
import "../Assests/Scss/ReportCard.scss";
import { Row, Col } from "react-bootstrap";
import { object } from "yup";
import NSFLOgo from "../Assests/Images/NSFLOgo.jpg";
import { renderToString } from "react-dom/server";
import { format } from "date-fns";
import CopyRight from "../../Student/Reusablecomponents/Copyright";

const SamagaraReportCard = () => {
    const location = useLocation();
    const { SetLoad } = useContext(LoadContext);
    const ReportsRef = useRef();
    const items = useSelector((state) => state.userDetailsData.LoginDetails);
    const USYear = useSelector((state) => state.SelecYearData.SYear);
    const [SWPercentage, SetSWPercentage] = useState();
    const [Performance, SetPerformance] = useState([]);
    const [SPerformance, SetSPerformance] = useState([]);
    const [LObjects, SetLObjects] = useState([]);

    const FetchallAPIs = async () => {
        SetLoad(true);
        try {
            const [SUbjectWisePercentage, Performance, LO] = await Promise.all([
                axiosInstance.get(
                    `/StudentResults/GetStudentSubjectwisePerformance?ContestCreationId=${location?.state?.CCID}&UserId=${items?.userId}&AssessmentType=${location.state.AType}`,
                ),
                axiosInstance.get(
                    `/StudentResults/SamgaraStudentPerfromanceReport?ContestCreationId=${location?.state?.CCID}&UserId=${items?.userId}&Grade=${items.grade}`,
                ),
                axiosInstance.get(
                    `/StudentResults/SamgaraStudentLOReport?ContestCreationId=${location?.state?.CCID}&UserId=${items?.userId}`,
                ),
            ]);
            const SWPTotal = {
                subjectName: "OVERALL",
                percentage: SUbjectWisePercentage.data?.[0]?.overallPercentage,
                obtainedCredits: SUbjectWisePercentage.data?.reduce((sum, item) => sum + item.obtainedCredits, 0,),
                totalCredits: SUbjectWisePercentage.data?.reduce((sum, item) => sum + item.totalCredits, 0,),
            };
            SetSWPercentage([SWPTotal, ...SUbjectWisePercentage.data]);

            const PerformanceData = Performance.data.slice(2).reduce((acc, item) => {
                if (!acc[item.subjectName]) {
                    acc[item.subjectName] = [];
                }

                acc[item.subjectName].push(item);

                return acc;
            }, {});
            SetSPerformance(PerformanceData)
            SetPerformance(Performance.data);

            const LObjects = LO.data.reduce((acc, item) => {
                if (!acc[item.subjectName]) {
                    acc[item.subjectName] = [];
                }

                acc[item.subjectName].push(item);

                return acc;
            }, {});
            SetLObjects(LObjects);
        } catch (err) {
            console.log(err);
        } finally {
            SetLoad(false);
        }
    };
    useEffect(() => {
        FetchallAPIs();
    }, []);

    const SubColors = (Sub) => {
        switch (Sub) {
            case "English":
                return ["#e2efe7", "#16a349", "📗"];
            case "Mathematics":
                return ["#eff6ff", "#2350d3", "📐"];
            case "Science":
                return ["#ec6722", "#ffc7aa"];
            case "Physics and Chemistry":
                return ["#875998", "#dcaded"];
            case "Biology":
                return ["#7d859e", "#e7e7e7"];
            case "OVERALL":
                return ["#effdf9", "#2f6e56", "📊"];
            case "BioTechnology":
                return ["#bb995f", "#d8bc8d"];
            case "Hindi":
                return ["#f96393", "#f9a0bc"];
            case "Telugu":
                return ["#AD46FF", "#d6a2ff"];
            default:
                return ["#5657d4", "#92b5ff"];
        }
    };

    const Percentagecolor = (e) => {
        switch (true) {
            case e <= 50:
                return "#da2626";
            case e > 50 && e <= 74:
                return "#f49e0a";
            case e > 74:
                return "#16a349";
        }
    };

    const InsightsColor = (insight) => {
        switch (insight) {
            case "Competent":
                return ["#16a349", "#166434", "#effdf4"];
            case "Bridge the Gap":
                return ["#f49e0a", "#b35208", "#fffbeb"];
            case "Remediation Need":
                return ["#db2626", "#da2626"];
        }
    }

    const replaceCanvasWithImages = () => {
        const canvases = document.querySelectorAll("canvas");
        canvases.forEach((canvas) => {
            const img = document.createElement("img");
            img.src = canvas.toDataURL("image/png");
            img.style.width = canvas.style.width;
            img.style.height = canvas.style.height;
            img.className = "chart-image";
            canvas.replaceWith(img);
        });
    };

    const copyAllStyles = () => {
        let styles = "";
        for (let sheet of document.styleSheets) {
            try {
                if (sheet.href) {
                    styles += `<link rel="stylesheet" href="${sheet.href}" />`;
                } else if (sheet.cssRules) {
                    // inline style blocks (used by SCSS injected styles)
                    let rules = "";
                    for (let rule of sheet.cssRules) {
                        rules += rule.cssText;
                    }
                    styles += `<style>${rules}</style>`;
                }
            } catch (err) {
                console.log("Skipping stylesheet", err);
            }
        }
        return styles;
    };

    const DownloadPDF = async () => {
        try {
            const payload = {
                userTypeId: items?.userTypeId || 0,
                userId: items?.userId || 0,
                reportType: "Student Report Card SAMAGRA",
                contestCreationId: location.state?.CCID || 0,
                assessmentTypeId: location?.state?.AType || 0
            };
            await axiosInstance.post("/NCLAdmin/InsertReportExportLog", payload);

        } catch (error) {
            console.error("Error logging report download:", error);
        }
        const stylesheets = copyAllStyles();
        replaceCanvasWithImages();
        const printContents = ReportsRef.current.innerHTML;
        const printWindow = window.open("", "", "height=800,width=600");
        const filename = `NCP_ReportCard_${items?.fullName}_${AssessmentName(
            location?.state?.AType,
        )}_${location?.state?.Date}`;
        printWindow.document.write(`
    <html>
      <head>
      ${stylesheets}
        <style>
          /* General styles for print */
          @media print {
            body {
            font-size: 12px;
              position: relative;
               -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
            }
           
 
  .print-only {
    display: block !important;
  }
    
    table th {
     font-size: 12px;
 
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
}
  table tbody td,.ft-18 {
  font-size: 12px !important;
}
            /* Watermark style */
            .watermark {
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%) rotate(-55deg);
              font-size: 80px;
              color: rgba(0, 0, 0, 0.06); /* low opacity */
              pointer-events: none;
              z-index: 9999;
              white-space: nowrap;
            }
            
            .Icons-Div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
  gap: 20px;
}

.Icons-Div div {
  flex: 1;
  text-align: center;
}
  .RC_Details,.RC_Details div div{
  gap:5px !important;}
   .RC_Details div div div{
   padding: 5px!important;}
.Icons-Div img {
              width: 20%;
              // height: 60px;
            }
             
                   .EndReport{
                  margin-top: 15px;
              }
                   .SubHeading,.MainHeading{
 font-weight:700 !important;
 font-size: 14px;}

      
            /* Ensure watermark appears on every page */
            @page {
              size: A4;
              margin: 7mm;
            }
          }
        </style>
      </head>
      <body>
      <div class="p-3 m-2" style="border: 2px solid #2f6e56; border-radius: 20px;">
      <div class="Icons-Div">
       <img src="${NSFLOgo}" alt="NSF Logo"/>
       <div class="MainHeading" style="color: #2f6e56">STUDENT REPORT CARD</div>
       <div></div>
      </div>
<hr/>
<div class="Icons-Div">
<div class="MainHeading">${location?.state?.AssTypeNo} Assessment ${location?.state?.Date} </div>
  </div>

        <div class="dflex JSBetween gap-3 ">
            <div class="dflex flexd-column alignitems" style="white-space: nowrap;"><b class="dflex gap-1" style=" color: #5b8c7e">${renderToString(<FaPenToSquare />)}STUDENT NAME</b> <b style="color:#2350d3">${items?.fullName}</b> </div>
            <div class="dflex flexd-column alignitems" style="white-space: nowrap;"><b class="dflex gap-1" style="color: #5b8c7e"> ${renderToString(<FaGraduationCap />)}GRADE / SECTION</b> <b>Grade ${items?.grade} - Section ${items.section}</b> </div>
            <div class="dflex flexd-column alignitems" style="white-space: nowrap;"><b class="dflex gap-1" style="color: #5b8c7e">${renderToString(<HiMiniIdentification />)}STUDENT ID</b> <b>${items?.studentId}</b> </div>
            <div class="dflex flexd-column alignitems" style="text-wrap-mode: wrap;"><b class="dflex gap-1" style="color: #5b8c7e">${renderToString(<FaSchool />)}SCHOOL</b> <b>${items?.schoolName}</b> </div>
          </div>
          </div>
        <div class="watermark">NORTH SOUTH FOUNDATION</div>
   
      ${printContents}
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
     

<div className="dflex flexd-column">
      <span className="">
        Generated by <strong>NorthSouth Foundation</strong> · Samagra Assessment
      </span>
</br>
      <span style="color:#a4b0c2">Confidential Student Record</span>
</br>

      <span style="color:#a4b0c2" >Printed on: <b  style="color:#64748b">${format(new Date(), "dd MMM yyyy")}</b></span>
</br>

      <span style="color: #2f6f57" > www.northsouth.org </span>
    </div>

      <script>
          window.onload = function() {
            setTimeout(() => {
              document.title = "${filename}";
              window.print();
              window.close();
              }, 400);
              }
              <\/script>
              </body>
              </html>
              `);
        printWindow.document.close();
    };
    //  <div class="Icons-Div"> <div>**  End of the Report  **</div></div>
    return (
        <>
            <div className="Instructions-pages p-5">
                <div className="p-3 mb-3" style={{ border: "2px solid #2f6e56", borderRadius: "20px" }}>
                    <div className="dflex JSBetween alignitems">
                        <div></div>
                        <div className="dflex JCCenter flexd-column gap-2 alignitems">
                            <div className="MainHeading mt-2" style={{ color: "#2f6e56" }}> STUDENT REPORT CARD </div>
                            <div className="SubHeading"> {location?.state?.AssTypeNo} Assessment {location?.state?.Date} </div>
                        </div>
                        <button className="Buttons p-2" onClick={() => { SWPercentage?.length > 0 && DownloadPDF() }}> Download Report</button>
                    </div>
                    <hr />
                    <div className="dflex JSBetween ">
                        <div className="dflex flexd-column alignitems" >
                            <b style={{ color: "#5b8c7e" }}> <FaPenToSquare /> STUDENT NAME </b>
                            <b style={{ color: "#2350d3" }}>{items?.fullName}</b>
                        </div>
                        <div className="dflex flexd-column alignitems">
                            <b style={{ color: "#5b8c7e" }}> <FaGraduationCap /> GRADE / SECTION </b>
                            <b> Grade {items?.grade} - Section {items.section}</b>
                        </div>
                        <div className="dflex flexd-column alignitems">
                            <b style={{ color: "#5b8c7e" }}> <HiMiniIdentification /> STUDENT ID </b>
                            <b>{items?.studentId}</b>
                        </div>
                        <div className="dflex flexd-column alignitems">
                            <b style={{ color: "#5b8c7e" }}> <FaSchool /> SCHOOL </b>
                            <b>{items?.schoolName}</b>
                        </div>
                    </div>
                </div>
                {SWPercentage?.length > 0 ?
                    <div ref={ReportsRef}>

                        <div className="dflex JSBetween mb-2">
                            <div className="MainHeading">Overall Performance</div>
                            <div></div>
                        </div>
                        <div className="dflex gap-3 RC_Details">
                            {SWPercentage?.map((SDetails) => (
                                <div className="Card  w-100 "
                                    style={{ backgroundColor: SubColors(SDetails.subjectName)[0], borderLeft: `5px solid ${SubColors(SDetails.subjectName)[1]}` }}>
                                    <div style={{ color: SubColors(SDetails.subjectName)[1] }}>{SubColors(SDetails.subjectName)[2]} <b>{SDetails.subjectName} AVERAGE</b></div>
                                    <div className="fs-1" style={{ color: Percentagecolor(SDetails.percentage) }}><b>{SDetails.percentage}%</b></div>
                                    <div style={{ color: "#64748a", fontSize: "12px" }}>{SDetails.obtainedCredits}/{SDetails.totalCredits} Correct</div>
                                </div>
                            ))}
                        </div>

                        <div className="dflex JSBetween mt-3 mb-2">
                            <div className="MainHeading">Subject Performance</div>
                            <div></div>
                        </div>
                        <div className="dflex gap-3">
                            {Object.keys(SPerformance)?.map((Sub) => (<>
                                <div className="Card w-100" style={{ borderLeft: `5px solid ${SubColors(Sub)[1]}` }}>
                                    <div className="SubHeading">{SubColors(Sub)[2]} {Sub} Performance</div>
                                    <div>
                                        <div className="mt-2 dflex JSBetween">
                                            <span>Registered Grade:</span>
                                            <strong>Grade {items.grade}</strong>
                                        </div>
                                        <div className="mt-1 dflex JSBetween">
                                            <span>Current Grade Level:</span>
                                            <strong >{Performance.slice(0, 2).filter((item) => item?.subjectName == Sub)?.[0]?.mastereryLevel}
                                                {Performance.slice(0, 2).filter((item) => item?.subjectName == Sub)?.[0]?.currentGradeLevel}
                                            </strong>
                                        </div>
                                    </div>

                                    <div className="p-2" style={{ backgroundColor: SubColors(Sub)[0], borderRadius: "5px" }}>
                                        {SPerformance[Sub].map((item, index) => (
                                            <div className="dflex JSBetween mt-1">
                                                <span>{item?.gradeLevel}</span>
                                                <span style={item?.status === "Correct" ? { color: "#15803d" } : { color: "#da2626" }} >
                                                    <b>{item?.comparedGrades} {item?.status === "Correct" ? "✔" : "✘"}</b>
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </>))}
                        </div>
                        <div>
                            <div className="dflex JSBetween mt-3 mb-2">
                                <div className="MainHeading">Performance Insights</div>
                                <div className="PInsights dflex gap-3">
                                    <div><span style={{ color: "#166434" }}>Competent</span> <span>Passed all levels</span></div>
                                    <div><span style={{ color: "#b35208" }}>Bridge the Gap</span> <span>Passed 2+ levels</span></div>
                                    <div><span style={{ color: "#b81c1c" }}>Remediation Need</span> <span>Passed Under 2</span></div>
                                </div>
                            </div>
                            <div className="dflex gap-3">
                                {Performance.slice(0, 2).map((Sub) => (
                                    <div className="Card dflex w-100" style={{ backgroundColor: InsightsColor(Sub?.performanceStatus)?.[2], color: InsightsColor(Sub?.performanceStatus)?.[1], borderLeft: `5px solid ${InsightsColor(Sub?.performanceStatus)?.[0]}` }}>
                                        <div style={{ fontSize: "40px" }}>{Sub?.subjectName === "English" ? "📈" : "🌟"} </div>
                                        <div>
                                            <div className="fs-6 text-uppercase"><b>{Sub?.subjectName} STATUS</b></div>
                                            <div className="fs-3"><b>{Sub?.performanceStatus}</b></div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                        </div>
                        <div className="dflex JSBetween mt-3 mb-2">
                            <div className="MainHeading">Learning Objectives</div>
                            <div></div>
                        </div>
                        <Row >
                            {Object.keys(LObjects).map((subject) => (
                                <Col className="dflex">
                                    <div className="Card" key={subject}>
                                        <div className="SubHeading">{subject === "English" ? "📚" : SubColors(subject)[2]} {subject} Learning Objectives</div>

                                        <table className="mt-3 SSLOTable">
                                            <thead style={{ backgroundColor: SubColors(subject)[0] }}>
                                                <th>S.No</th> <th>Learning Object</th> <th>Score</th> <th>Questions</th>
                                            </thead>
                                            <tbody>
                                                {LObjects[subject]?.map((LO, index) => (
                                                    <tr>
                                                        <td>{index + 1}</td>
                                                        <td>{LO.learningOutcomes}</td>
                                                        <td style={{ color: Percentagecolor(LO.percenatge) }}><b>{LO.percenatge}%</b></td>
                                                        <td><b>{LO.assessedQuestionIds?.split(",").map((Q, index) =>
                                                            <span style={LO.responseStatus?.split(",")[index] == 0 ? { color: "#da2626" } : { color: "#16a349" }}>{Q} {index < LO.assessedQuestionIds.split(",").length - 1 ? ", " : ""}</span>)}</b></td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>
                    :
                    <div className="ErrorMessage">
                        {process.env.REACT_APP_NODATAFOUND_Participated}
                    </div>
                }
                <CopyRight />
            </div>
        </>
    )
}
export default SamagaraReportCard;